export default "__VITE_ASSET__CqrT0Dkd__"